import {
  GET_MASTER_REPORTING_ITEM_LIST,
  GET_MASTER_REPORTING_ITEM_LIST_SUCCESS,
  GET_MASTER_REPORTING_ITEM_LIST_FAILURE,
  GET_MASTER_REPORTING_ITEM_DATA,
  GET_MASTER_REPORTING_ITEM_DATA_SUCCESS,
  GET_MASTER_REPORTING_ITEM_DATA_FAILURE,
} from "./actionType";
// Actions
//Get Master Reporting item list
export const getMasterReportingItemList = () => ({
  type: GET_MASTER_REPORTING_ITEM_LIST,
});
export const getMasterReportingItemListSuccess = (data) => ({
  type: GET_MASTER_REPORTING_ITEM_LIST_SUCCESS,
  payload: data,
});
export const getMasterReportingItemListFailure = (error) => ({
  type: GET_MASTER_REPORTING_ITEM_LIST_FAILURE,
  payload: error,
});

//Get Master Reporting item data
export const getMasterReportingItemData = (data) => ({
  type: GET_MASTER_REPORTING_ITEM_DATA,
  payload: data,
});
export const getMasterReportingItemDataSuccess = (data) => ({
  type: GET_MASTER_REPORTING_ITEM_DATA_SUCCESS,
  payload: data,
});
export const getMasterReportingItemDataFailure = (error) => ({
  type: GET_MASTER_REPORTING_ITEM_DATA_FAILURE,
  payload: error,
});
